import React, { useState, useEffect } from 'react';
import { siteConfig, navigation } from '../data/content';

const Navigation = ({ currentPage, onNavigate, onScrollTo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (item) => {
    setMenuOpen(false);
    if (item.type === 'page') {
      onNavigate(item.id);
    } else {
      onScrollTo(item.id);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-stone-50/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Company Name */}
          <button
            onClick={() => onNavigate('home')}
            className="font-display text-2xl tracking-wide text-stone-800 hover:text-amber-700 transition-colors"
          >
            {siteConfig.companyName}
          </button>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10">
            {navigation.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item)}
                className={`nav-link ${
                  currentPage === item.id ? 'nav-link-active' : 'nav-link-inactive'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2"
            aria-label="Toggle menu"
          >
            <div className="w-6 flex flex-col gap-1.5">
              <span
                className={`h-px bg-stone-800 transition-all duration-300 ${
                  menuOpen ? 'rotate-45 translate-y-2' : ''
                }`}
              />
              <span
                className={`h-px bg-stone-800 transition-all duration-300 ${
                  menuOpen ? 'opacity-0' : ''
                }`}
              />
              <span
                className={`h-px bg-stone-800 transition-all duration-300 ${
                  menuOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-20 left-0 right-0 bg-stone-50 border-t border-stone-200 transition-all duration-300 ${
          menuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {navigation.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavClick(item)}
              className="font-body text-sm tracking-widest uppercase text-stone-600 hover:text-amber-700 text-left py-2"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
